import { cn } from "@productlane/lib/src/cn"

import { useReadTransition } from "@/lib/use-read-transition"

interface Props {
	title: string
	isUnread: boolean
	className?: string
}

export function NotificationTitle({ title, isUnread, className }: Props) {
	// -translate-x-3.5 is the dot plus the gap: 8px + 6px.
	const { showDot, dotClassName, slideClassName } = useReadTransition(
		isUnread,
		"-translate-x-3.5",
	)

	return (
		<p
			className={cn(
				"flex min-w-0 items-center gap-1.5 text-[13px]",
				isUnread ? "font-medium text-primary" : "text-secondary",
				className,
			)}
		>
			{showDot && (
				<span
					data-read-dot
					className={cn(
						"h-2 w-2 flex-none rounded-full bg-green-500 dark:bg-green-400",
						dotClassName,
					)}
				/>
			)}
			<span className={cn("min-w-0 truncate", slideClassName)}>{title}</span>
		</p>
	)
}
